// Lodash
import { get } from 'lodash';

// STORE ACTION AND STATE
import { Actions, ActionTypes } from './actions';
import { initialState, TaskState } from './state';
import { Actions as AuthActions, ActionTypes as AuthActionTypes } from '../../auth/store/actions';


/**
 * This effect is for listen Task actions, execute auth service call and dispatch in Task reducer.
 * For Task api call purpose.
 *
 * @author Nirmal Jodhani <nirmal.jodhani@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 19/05/2020 (Nirmal Jodhani <nirmal.jodhani@saeculumsolutions.com>)  created task reducer
 */
export function reducer(state = initialState, action: Actions | AuthActions): TaskState {
  switch (action.type) {
    // Task COMMON METHOD
    case ActionTypes.TASK_COMMON: {
      return state;
    }
    // Task Success COMMON METHOD
    case ActionTypes.TASK_COMMON_SUCCESS: {
      // commonly store and handle all Task modules
      return {
        ...state,
        [action.response.common.STATE]: get(action.response.data, action.response.common.API_RESPONSE),
      };
    }

    // CLEAR_REDUCER METHOD ON LOGOUT
    case AuthActionTypes.CLEAR_REDUCER: {
      return initialState;
    }
    // CLEAR_BUSINESS_REDUCER METHOD ON BUSINESS CHANGE
    case AuthActionTypes.CLEAR_BUSINESS_REDUCER: {
      return initialState;
    }
    // DEFAULT
    default:
      return state;
  }
}
